import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, createVNode as _createVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = {
  class: "tab-content",
  id: "playlist-list"
}
const _hoisted_2 = ["id", "aria-labelledby"]

import PresentedStory from './list-of-stories-components/PlaylistPagePresentedStory.vue';
import { PlaylistStoryDto } from '@/models/PlaylistPageTypes'
import { computed } from 'vue'
import { usePlaylistStore } from '@/stores/playlistStore'


export default /*#__PURE__*/_defineComponent({
  __name: 'PlaylistPagePresentedStoriesPanes',
  props: {
    stories: null
  },
  setup(__props: any) {

const props = __props as {
    stories?: Array<PlaylistStoryDto>
};

const playlistStore = usePlaylistStore()

const currentElement = computed(() => playlistStore.currentElement)



function onVideoEnd(story: PlaylistStoryDto) {
    if (playlistStore.autoplayMode) {
        playlistStore.SetTimerCycle(props.stories, story)
    }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.stories, (story) => {
      return (_openBlock(), _createElementBlock("div", {
        key: story.KeyId + '-toggle',
        class: _normalizeClass(["tab-pane fade row-top", story.KeyId == _unref(currentElement) || story == __props.stories?.at(0) ? 'show active' : '']),
        id: `${story.KeyId}-toggle`,
        role: "tabpanel",
        "aria-labelledby": story.KeyId,
        tabindex: "0"
      }, [
        _createVNode(PresentedStory, {
          story: story,
          onVideoend: onVideoEnd
        }, null, 8, ["story"])
      ], 10, _hoisted_2))
    }), 128))
  ]))
}
}

})